import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ content: {}, loading: true, refresh: () => {} });

const FALLBACK = {
  hero: {
    overline: "Interventional Radiology — Vascular & Endovascular",
    line1: "Senior-led",
    line2: "vascular care,",
    line3: "without the guesswork.",
    sub: "Dr Tegbir Singh Sidhu — Principal Consultant, Interventional Radiology at Max Super Speciality Hospital, Mohali. Continuity from first call to final follow-up.",
    cta_primary: "Speak to Dr Sidhu's team",
    cta_secondary: "Urgent evaluation",
  },
  conditions: [
    "Aortic Aneurysm","Peripheral Artery Disease","Deep Vein Thrombosis","Varicose Veins",
    "Dialysis Access","Uterine Fibroids","Prostate Artery Embolisation","Liver Cancer TACE",
    "Kidney Cancer Ablation","Portal Hypertension","Biliary Drainage","Nephrostomy",
    "Vascular Malformations","Pelvic Congestion","Varicocele","Carotid Stenting",
    "Renal Artery Stenosis","May-Thurner Syndrome","IVC Filter","Thrombolysis",
    "Foot Salvage / CLI","Diabetic Foot Angioplasty","Haemoptysis Embolisation",
    "GI Bleed Embolisation","Trauma Embolisation","Chemo Port Placement",
    "PICC Line","Tunnelled Catheters","Pulmonary Embolism","Aortic Dissection",
    "Aneurysm Coiling","AV Fistula Salvage","Lymphatic Interventions","Y-90 Radioembolisation",
  ],
};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...FALLBACK, ...data });
    } catch {
      setContent(FALLBACK);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <ContentContext.Provider value={{ content, loading, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
